import React from "react";

const SingleBlindedPeerReview = () => {
  return (
    <React.Fragment>
      <h1>Peer review</h1>
      <p>
        Cureus Journals are peer-reviewed journals. All articles accepted for peer review undergo a
        single-blind pre-publication peer review process in which reviewers know the identity of the
        authors, but authors do not know the identity of the reviewers.
      </p>
      <p>
        Reviewers are anonymized through Cureus Journals' automated system. Once a reviewer accepts
        the review invitation, they are assigned a Greek letter to be used for identification
        purposes by the authors (e.g. Reviewer Alpha). Any supplemental material included with the
        article is also subject to peer review. Reviews are not posted with the published articles.
      </p>
      <p>
        Authors are required to suggest a minimum of five reviewers when submitting their draft.
        Authors are expected to suggest unbiased and expert reviewers who will provide critical
        feedback. These reviewers are vetted by the editorial staff of Cureus Journal of Computer
        Science (CJCS) prior to peer review. Students are ineligible to serve as peer reviewers.
        Positive reviews lacking substantial constructive feedback are closely scrutinized by our
        editors and red-flagged for possible rejection. Think of it this way: your peer reviewers
        will be reviewed; therefore, inviting credible reviewers is of paramount importance.
      </p>
      <p>
        In addition to author-suggested reviewers, a minimum of six peer reviewers comprising CJCS
        Editorial Board members and relevant specialists who have either volunteered for the panel
        or previously published as authors in Cureus Journals are automatically invited by CJCS.
        Please note that author-invited peer reviewers do not make the final decision.
      </p>
      <p>
        This ensures that a minimum of 11 peer reviewers is invited to review each article. Once the
        article has entered peer review, three additional reviewers are automatically invited by
        CJCS every two days to ensure that the article completes peer review in a timely fashion.
        CJCS identifies peer reviewers based on author-provided keywords and categories. Therefore,
        selecting the right categories and keywords is of paramount significance. Two completed
        reviews from CJCS-invited reviewers are required to complete the peer review process.
      </p>
      <p>
        <strong>
          Post peer review, authors and editors have an option of sending the manuscript for
          re-review. During re-review, reviewers can scrutinize the authors’ responses to reviewers’
          feedback and take the final decision.
        </strong>
      </p>
      <p>
        Peer reviewers play a vital role in scientific publishing. Their expert evaluations and
        recommendations guide editors in their decisions and ensure that published research is
        valid, rigorous, and credible. Editors select peer reviewers primarily because of their
        in-depth knowledge of the subject matter or methods of the work they are asked to evaluate.
        This expertise is invaluable and irreplaceable.
      </p>
      <p>
        Peer reviewers are accountable for the accuracy and views expressed in their reports, and
        the peer review process operates on a principle of mutual trust between authors, reviewers
        and editors. Despite rapid progress, generative AI tools have considerable limitations: they
        can lack up-to-date knowledge and may produce nonsensical, biased, and/or false information.
        Manuscripts may also include sensitive or proprietary information that should not be shared
        outside the peer review process. For these reasons we ask that, while Springer Nature
        explores providing our peer reviewers with access to safe AI tools, peer reviewers do not
        upload manuscripts into generative AI tools.
      </p>
      <p>
        If any part of the evaluation of the claims made in the manuscript was in any way supported
        by an AI tool, we ask peer reviewers to declare the use of such tools transparently in the
        peer review report.
      </p>
    </React.Fragment>
  );
};

export default SingleBlindedPeerReview;
